import { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../../../../../config/constants";
// Components
import { MainDiv, Title, SelectDiv, ReasonInfo, Textarea, ActionsDiv, CancelButton, SaveButton } from "./styles";
import UseFetch from "../../../../../../../../config/useFetch";
import Popup from "../../../../../../../popup";
import SelectInput from "../../../../../../../selectInput";
// Assets
import SelectArrow from "../../../../../../../../assets/icons/ico_arrow_down.svg";

const PrescriptionReason = ({ savePrescriptions, isShowingReasonPopup, setIsShowingReasonPopup }) => {
  const [reason, setReason] = useState("Select a reason");
  const [reasonError, setReasonError] = useState(false);
  const [reasonText, setReasonText] = useState("");
  const [reasonTextError, setReasonTextError] = useState(false);
  const { patientId } = useParams();
  const [options] = useState([
    "Select a reason",
    "Clinical Judgment",
    "Data Accuracy",
    "Patient Feedback or Observation",
    "Technical or Equipment Limitations",
    "Other reason (specify)",
  ]);

  const [optionValuesMapping] = useState({
    "Select a reason":
      "The Recommender System (RS) is optimized to achieve a specific objective. Editing its parameters may reduce its effectiveness within its intended scope. However, given your expertise, you may choose to override these settings.",
    "Clinical Judgment":
      "Patient-specific considerations such as physical limitations, cognitive impairments, or contraindications to certain activities (e.g., VR/AR intolerance).",
    "Data Accuracy": "The AI recommendation was based on incomplete, outdated, or incorrect patient data.",
    "Patient Feedback or Observation":
      "Direct insights from the patient, such as reported discomfort, motivational issues, or personal preferences.",
    "Technical or Equipment Limitations":
      "Issues related to device availability, software usability, or lack of compatibility with the patient’s context.",
    "Other reason (specify)": "",
  });

  const saveReason = async () => {
    if (reason === "Select a reason") {
      setReasonError(true);
      return toast.error("You must select a reason");
    }

    if (!reasonText) {
      setReasonTextError(true);
      return toast.error("You must write a reason");
    }

    const reasonObj = {
      reasonKey: reason,
      reason: reasonText,
    };

    await UseFetch(
      "post",
      `${WEB_SERVICE_MIMS}/recsys/add-prescription-change-reason/${patientId}`,
      new AbortController(),
      reasonObj
    ).catch((error) => {
      toast.error("Error sending data, please try again");
      console.log("Add prescription change reason: ", error);
    });

    await savePrescriptions();
  };

  const handleSetReasonValue = (e) => {
    const reasonKey = e.target.value;
    setReason(reasonKey);
    setReasonText(optionValuesMapping[reasonKey]);
    setReasonError(false);
    setReasonTextError(false);
  };

  const handleSetReasonTextValue = (e) => {
    setReasonText(e.target.value);
    setReasonTextError(false);
  };

  return (
    <Popup isShowed={isShowingReasonPopup} setIsShowed={setIsShowingReasonPopup} backgroundId="prescriptionReasonPopup">
      <MainDiv>
        <Title>Reason for prescription change</Title>
        <SelectDiv>
          <SelectInput
            id="reason"
            value={reason}
            onChange={handleSetReasonValue}
            padding="5px 25px 5px 10px"
            width="310px"
            arrowImg={SelectArrow}
            backgroundPosition="285px center"
            error={reasonError}
          >
            {options.map((option) => {
              return (
                <option key={option} value={option}>
                  {option}
                </option>
              );
            })}
          </SelectInput>
        </SelectDiv>
        {reason === "Select a reason" ? (
          <ReasonInfo>{optionValuesMapping[reason]}</ReasonInfo>
        ) : (
          <Textarea
            id="reasonText"
            value={reasonText}
            onChange={handleSetReasonTextValue}
            placeholder="Write your reason here..."
            error={reasonTextError}
          />
        )}
        <ActionsDiv>
          <CancelButton onClick={() => setIsShowingReasonPopup(false)}>Cancel</CancelButton>
          <SaveButton onClick={saveReason} background={reason === "Select a reason" ? "#b3b3b3" : "#26a9b6"}>
            Save prescription
          </SaveButton>
        </ActionsDiv>
      </MainDiv>
    </Popup>
  );
};

export default PrescriptionReason;
